import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { AnalyticsService, HubAnalyticsTab, StatCard, getDefaultDateRange } from '@shared/services/analytics.service';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { Hub, User } from '@shared/models';
import { LoadState } from '@app/main/analytics/loader-directive/loader.module';
import { GoogleChartInterface } from 'ng2-google-charts';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import * as moment from 'moment';

const orderedTabs = [
  HubAnalyticsTab.Overview,
  HubAnalyticsTab.Experiences,
];

@Component({
  selector: 'hub-stats',
  templateUrl: './hub-stats.component.html',
  styleUrls: ['./hub-stats.component.scss']
})
export class HubStatComponent implements OnInit {
  public hub: Hub;


  public trafficChart: GoogleChartInterface;
  public trafficDataStatus = LoadState.pending;
  public chartColorVisitors = '#247e8d';
  public chartColorGuests = '#5ca7b5';
  public activeTab = HubAnalyticsTab.Overview;

  date_from: Date;  // TODO: Default value 1 year
  date_to: Date;
  constructor(
    private _currentHub: CurrentHubService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,

  ) {

  }
  ngOnInit(): void {
    const defaultRange = getDefaultDateRange();
    this.date_from = defaultRange.date_from;
    this.date_to = defaultRange.date_to;
    this._currentHub.hubObservable.subscribe(async hub => {
      if (hub) {
        this.hub = hub;
      }
    })
    this._activatedRoute.queryParams.subscribe(async params => {
      this.activeTab = params.activeTab;
      let dateRangeChange = false;
      if (params.dateFrom && (!this.date_from || (this.date_from && this.date_from.getTime() !== parseInt(params.dateTo)))) {
        this.date_from = new Date(parseInt(params.dateFrom))
        dateRangeChange = true;
      }
      if (params.dateTo && (!this.date_to || (this.date_to && this.date_to.getTime() !== parseInt(params.dateTo)))) {
        this.date_to = new Date(parseInt(params.dateTo))
        dateRangeChange = true;
      }
      if (params.timePickerMode && params.timePickerMode === 'forever') {
        this.date_from = null;
        this.date_to = null;
      }
    })
  }


  openHelp(): void {
    window.open('http://help.spaces.wondavr.com/en/articles/3294026-analytics-dashboard');
  }
  getRelativeDate(date: Date): string {
    return moment(date).fromNow();
  }
  
  getSelectedIndex() {
    return orderedTabs.indexOf(this.activeTab) || 0;
  }

  onSelectedIndexChange(index: number): void {
    let newTab = HubAnalyticsTab.Overview;
    if (index >= 0 && index < orderedTabs.length) {
      newTab = orderedTabs[index];
    }

    const params: Params = { activeTab: newTab };
    this._router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }
}
